import { motion } from 'framer-motion'
import { Phone, Mail, MapPin, Clock, MessageCircle } from 'lucide-react'
import { contactInfo } from '../data'

export function AboutPage() {
  return (
    <>
      <section className="relative h-60 bg-gray-900 text-white">
        <div className="absolute inset-0 bg-cover bg-center opacity-30" style={{ backgroundImage: `url(/images/about-banner.jpg)` }}></div>
        <div className="container-custom h-full flex items-center relative z-10">
          <div>
            <h1 className="text-3xl md:text-4xl font-bold mb-4">关于我们</h1>
            <p className="text-lg text-white/80">了解我们的公司文化和发展历程</p>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container-custom">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ x: -50, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
            >
              <h2 className="text-3xl md:text-4xl font-bold mb-6">关于书香云库</h2>
              <p className="text-lg text-gray-600 mb-6">
                书香云库是一款用于解决当前教育体制下学生膳食改善流程化管理的软件系统，以"四方协同、数据共享、全程追溯"为核心，构建从采购、配送、验收到财务结算的一体化数字管理平台。
              </p>
              <p className="text-lg text-gray-600 mb-6">
                软件涵盖客户端（供应商、学校、教体局、财务端）及手机端（学校、供应商），为教体局、学校食堂、供货商、乡镇财务管理四方提供信息化管理解决方案，实现流程标准化、数据实时化、监管全程化、安全可追溯。
              </p>
              <p className="text-lg text-gray-600">
                我们的使命是通过技术创新，提升学校食堂供应链管理的效率和透明度，保障食品安全，为学生提供健康、安全的饮食环境，实现"数据多跑路、人员少跑腿、监管无盲区、安全有保障"的现代化治理目标。
              </p>
            </motion.div>
            <motion.div
              initial={{ x: 50, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="bg-gray-50 p-8 rounded-2xl"
            >
              <h3 className="text-2xl font-semibold mb-6">联系方式</h3>
              <ul className="space-y-4">
                <li className="flex items-start space-x-3">
                  <Phone className="w-5 h-5 text-primary-500 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-600">{contactInfo.phone}</span>
                </li>
                {contactInfo.email && (
                  <li className="flex items-start space-x-3">
                    <Mail className="w-5 h-5 text-primary-500 mt-0.5 flex-shrink-0" />
                    <span className="text-gray-600">{contactInfo.email}</span>
                  </li>
                )}
                <li className="flex items-start space-x-3">
                  <MapPin className="w-5 h-5 text-primary-500 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-600">{contactInfo.address}</span>
                </li>
                <li className="flex items-start space-x-3">
                  <Clock className="w-5 h-5 text-primary-500 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-600">{contactInfo.workingHours}</span>
                </li>
                <li className="flex items-start space-x-3">
                  <MessageCircle className="w-5 h-5 text-primary-500 mt-0.5 flex-shrink-0" />
                  <span className="text-gray-600">{contactInfo.wechat}</span>
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  )
}
